import { http } from '@/http/index'

async function updatePaidMessage(messageId, formData) {
	return http.put(`/paid-messages/${messageId}`, formData).then((response) => response)
}

export { updatePaidMessage }
